The identifier for the `ApplicationQuestionnaireComponent`.
